export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/home';
export const ACCOUNT = '/account';

export const GIGS = '/gigs';
export const GIGDETAIL = '/gigdetail/:gigid';

export const COURSES = '/courses/';

export const CERTIFICATE = '/certificate/:courseid';



// WEBPACK FOOTER //
// ./src/constants/routes.js